import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    width: 0;
    height: 8px;
    position: absolute;
    border: 1px solid #C7EFDA;
    top: 15px;
    left: ${`${displayState.progress}%`};
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })